/**
 * Primitivo de skeleton. Usa animate-pulse de Tailwind por defecto.
 * Variants:
 *  - text: bloques de texto inline (heredan altura del contexto)
 *  - rect: rectángulos para imágenes, cards, botones
 *  - circle: avatares, íconos circulares
 */
const VARIANTS = {
  text:   'rounded',
  rect:   'rounded-xl',
  circle: 'rounded-full',
};

const Skeleton = ({
  variant = 'rect',
  width,
  height,
  className = '',
  count = 1,
  gap = '0.5rem',
}) => {
  const style = {
    width: width ?? '100%',
    height: height ?? (variant === 'text' ? '1em' : '1.5rem'),
  };

  if (count === 1) {
    return (
      <div
        aria-hidden="true"
        className={['animate-pulse bg-slate-200', VARIANTS[variant], className].join(' ')}
        style={style}
      />
    );
  }

  // Múltiples skeletons (ej: lineas de texto)
  return (
    <div className="flex flex-col" style={{ gap }} aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className={['animate-pulse bg-slate-200', VARIANTS[variant], className].join(' ')}
          style={{
            ...style,
            // Última línea más corta para sensación natural de párrafo
            width: i === count - 1 && variant === 'text' ? '70%' : style.width,
          }}
        />
      ))}
    </div>
  );
};

export default Skeleton;